import React from 'react';
import PropTypes from 'prop-types';

const CheckBox = ({
  children,
  checked,
  onChange,
  isDisabled,
  name,
  id,
  related,
  onClick,
}) => {

  return (
    <div className="checkbox"
      style={{ userSelect: 'none' }}>
      <input
        type="checkbox"
        name={name}
        id={id}
        checked={checked}
        onChange={onChange}
        disabled={isDisabled}
        data-related={related}
        onClick={onClick}
      />
      <label htmlFor={id}>{children}</label>
    </div>
  );
};

CheckBox.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func,
  name: PropTypes.string.isRequired,
  id: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  children: PropTypes.any,
  isDisabled: PropTypes.bool,
  related: PropTypes.array,

};

CheckBox.defaultProps = {
  children: '',
  isDisabled: false,
  related: [],
  checked: false,
}

export default CheckBox;